export default "__VITE_PUBLIC_ASSET__3d9319a9__"